/*Generated from the `:::slide{key="8edbd01d-05c2-42af-aa60-9bc9a698e0ab" slug="gloss-and-alias"}` (simplified/001/004/山.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "3",
      children: _jsx(html.p, {
        children: "On the card for 山, \"mountain\" appeared twice:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "3",
      children: _jsxs(html.p, {
        children: [_jsx(html.strong, {
          children: "mountain",
          components: html
        }), ": The ", _jsx(html.em, {
          children: "core meaning",
          components: html
        }), ", or ", _jsx(html.strong, {
          children: "gloss",
          components: html
        }), ", of 山 is ", _jsx(html.strong, {
          children: "mountain",
          components: html
        }), "\n", _jsx(html.em, {
          children: "mountain",
          components: html
        }), ": The ", _jsx(html.strong, {
          children: "alias",
          components: html
        }), " for 山 when used a component is ", _jsx(html.em, {
          children: "mountain",
          components: html
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "3",
      children: _jsxs(html.p, {
        children: ["In this case, the *", _jsx(html.em, {
          children: "gloss",
          components: html
        }), " and the ", _jsx(html.strong, {
          children: "alias",
          components: html
        }), " were the same, but this isn't always the case!"]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
